import SpriteSymbol from "../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-huilv-JPY",
  "use": "icon-huilv-JPY-usage",
  "viewBox": "0 0 180 180",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 180 180\" id=\"icon-huilv-JPY\"><g><circle transform=\"matrix(1 0 0 -1 0 180)\" cx=\"90\" cy=\"90\" r=\"90\" /><circle cx=\"90\" cy=\"90\" r=\"45\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol